import { useMemo } from 'react';
import QrRef from '../../QrComponents/QrRef';
import styles from './GeneratorQRDisplay.module.css';

export default function GeneratorQRDisplay({ state }) {

	const options = useMemo(() => state?.qrGenObj?.qr_style, [state]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <h3 className='text-center mb-2'>Generator QR</h3>
                <span className={styles.text} >Complete the sign up process above to unlock your QR's full potential.</span>
                {state.error ? 
                    <div className={styles.errorContainer} ><span className={styles.error}>{state.error}</span></div>
                :
                <>
                    <div className={styles.qrContainer}>
						<QrRef size={150} childQrOptions={options} />
                    </div>
                </>
                }
            </div>
        </div>
    );
};